import { render, staticRenderFns } from "./TankForm.vue?vue&type=template&id=21f78fe8&"
import script from "./TankForm.vue?vue&type=script&lang=js&"
export * from "./TankForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports